{
  "clinicalNotes": "บันทึกทางคลินิก",
  "noteType": "ประเภทบันทึก",
  "author": "ผู้เขียน",
  "dateTime": "วันที่/เวลา",
  "content": "เนื้อหา",
  "addNote": "เพิ่มบันทึก",
  "editNote": "แก้ไขบันทึก",
  "signNote": "ลงนามบันทึก",
  "signed": "ลงนามแล้ว",
  "unsigned": "ยังไม่ลงนาม",
  "types": {
    "progressNote": "บันทึกความก้าวหน้า",
    "admissionNote": "บันทึกรับเข้า",
    "dischargeNote": "บันทึกจำหน่าย",
    "consultNote": "บันทึกการปรึกษา",
    "procedureNote": "บันทึกหัตถการ"
  },
  "editor": {
    "newNote": "บันทึกใหม่",
    "titlePlaceholder": "ชื่อบันทึก…",
    "create": "สร้าง",
    "cancel": "ยกเลิก",
    "cosignFilterLabel": "แสดงเฉพาะบันทึกที่ต้องร่วมลงนาม",
    "emptyNoCosign": "ไม่มีบันทึกที่ต้องร่วมลงนาม",
    "emptyNoNotes": "ยังไม่มีบันทึก",
    "emptySelection": "เลือกบันทึกหรือสร้างใหม่",
    "emptySelectionHint": "เลือกจากรายการด้านซ้ายหรือคลิก \"+ บันทึกใหม่\" เพื่อเริ่ม",
    "unknownAuthor": "ไม่ทราบ",
    "needsCosignBadge": "ต้องร่วมลงนาม",
    "amendmentBanner": "การแก้ไขบันทึก #{{parentId}} — เหตุผล: {{reason}}",
    "signedBanner": "ลงนามโดย {{name}} เมื่อ {{when}} — บันทึกนี้อ่านได้อย่างเดียว",
    "signedByFallback": "แพทย์",
    "saving": "กำลังบันทึก…",
    "autoSaved": "บันทึกอัตโนมัติแล้ว",
    "actions": {
      "saveDraft": "บันทึกฉบับร่าง",
      "signNote": "ลงนามบันทึก",
      "amend": "แก้ไข",
      "cosign": "ร่วมลงนาม",
      "printLabel": "พิมพ์บันทึก"
    },
    "copyForward": "คัดลอกบันทึกล่าสุด",
    "copyForwardHint": "จะคัดลอกบันทึกที่ลงนามเมื่อ {{date}} — ตรวจสอบและปรับปรุงทุกบรรทัด",
    "copiedForwardBadge": "คัดลอกมา"
  },
  "dialog": {
    "sign": {
      "title": "ลงนามบันทึก",
      "body": "ยืนยันการลงนามบันทึกนี้? การกระทำนี้ไม่สามารถยกเลิกได้ บันทึกจะกลายเป็นอ่านได้อย่างเดียวหลังลงนาม",
      "cancel": "ยกเลิก",
      "confirm": "ยืนยันการลงนาม"
    },
    "amend": {
      "title": "แก้ไขบันทึก",
      "body": "โปรดระบุเหตุผลของการแก้ไขนี้ บันทึกจะถูกอัปเดตและทำเครื่องหมายว่าแก้ไขแล้ว",
      "reasonPlaceholder": "เหตุผลการแก้ไข…",
      "cancel": "ยกเลิก",
      "confirm": "ยืนยันการแก้ไข"
    },
    "cosign": {
      "title": "ร่วมลงนามบันทึก",
      "body": "ยืนยันการร่วมลงนามบันทึกนี้? หมายความว่าท่านได้ตรวจสอบและเห็นด้วยกับเนื้อหาของบันทึก",
      "cancel": "ยกเลิก",
      "confirm": "ยืนยันการร่วมลงนาม"
    }
  },
  "toast": {
    "created": "สร้างบันทึกแล้ว",
    "createFailed": "สร้างบันทึกไม่สำเร็จ",
    "titleRequired": "โปรดกรอกชื่อบันทึก",
    "draftSaved": "บันทึกฉบับร่างแล้ว",
    "signed": "ลงนามบันทึกสำเร็จ",
    "signFailed": "ลงนามบันทึกไม่สำเร็จ",
    "amended": "แก้ไขบันทึกสำเร็จ",
    "amendFailed": "แก้ไขบันทึกไม่สำเร็จ",
    "amendReasonRequired": "โปรดระบุเหตุผลของการแก้ไข",
    "cosigned": "ร่วมลงนามบันทึกสำเร็จ",
    "cosignFailed": "ร่วมลงนามบันทึกไม่สำเร็จ"
  },
  "status": {
    "draft": "ฉบับร่าง",
    "unsigned": "ยังไม่ลงนาม",
    "signed": "ลงนามแล้ว",
    "amended": "แก้ไขแล้ว",
    "cosigned": "ร่วมลงนามแล้ว",
    "cosignNeeded": "ต้องร่วมลงนาม",
    "pendingSignature": "รอการลงนาม",
    "addendum": "บันทึกเพิ่มเติม",
    "cosignPending": "รอร่วมลงนาม"
  },
  "worklist": {
    "title": "รายการบันทึกที่ยังไม่ลงนาม",
    "backToDashboard": "แดชบอร์ด",
    "filtersHeading": "ตัวกรอง",
    "filterAllNoteTypes": "ทุกประเภทบันทึก",
    "filterAllStatuses": "ทุกสถานะ",
    "filterAuthorPlaceholder": "กรองตามผู้เขียน…",
    "dateFromAria": "วันที่เริ่ม",
    "dateToAria": "วันที่สิ้นสุด",
    "columns": {
      "patient": "ผู้ป่วย",
      "mrn": "MRN",
      "noteType": "ประเภทบันทึก",
      "noteTitle": "ชื่อบันทึก",
      "author": "ผู้เขียน",
      "created": "สร้างเมื่อ",
      "status": "สถานะ",
      "actions": "การดำเนินการ"
    },
    "actions": {
      "signSelected": "ลงนามที่เลือก ({{count}})",
      "signing": "กำลังลงนาม…",
      "open": "เปิด",
      "refresh": "รีเฟรช"
    },
    "loading": "กำลังโหลดบันทึก…",
    "empty": "ไม่พบบันทึกที่ยังไม่ลงนาม",
    "loadError": "โหลดบันทึกที่ยังไม่ได้ลงนามไม่สำเร็จ",
    "retry": "ลองอีกครั้ง",
    "toast": {
      "noneSelected": "ยังไม่ได้เลือกบันทึก",
      "signed_one": "ลงนามบันทึก {{count}} รายการสำเร็จ",
      "signed_other": "ลงนามบันทึก {{count}} รายการสำเร็จ",
      "signFailed": "ลงนามบันทึกบางรายการไม่สำเร็จ",
      "partiallySigned_one": "ลงนามบันทึก {{count}} รายการสำเร็จ {{failed}} รายการไม่สำเร็จ",
      "partiallySigned_other": "ลงนามบันทึก {{count}} รายการสำเร็จ {{failed}} รายการไม่สำเร็จ"
    }
  },
  "type": {
    "progress": "บันทึกความก้าวหน้า",
    "historyPhysical": "H&P",
    "admission": "บันทึกรับเข้า",
    "discharge": "สรุปการจำหน่าย",
    "consult": "บันทึกการปรึกษา",
    "procedure": "บันทึกหัตถการ",
    "operative": "บันทึกการผ่าตัด",
    "nursing": "บันทึกการพยาบาล"
  },
  "template": {
    "list": {
      "title": "เทมเพลตบันทึก",
      "backToDashboard": "แดชบอร์ด",
      "newButton": "เทมเพลตใหม่",
      "columns": {
        "name": "ชื่อ",
        "noteType": "ประเภทบันทึก",
        "specialty": "สาขา",
        "sections": "ส่วน",
        "status": "สถานะ",
        "actions": "การดำเนินการ"
      },
      "active": "ใช้งาน",
      "inactive": "ไม่ใช้งาน",
      "loading": "กำลังโหลดเทมเพลต…",
      "empty": "ยังไม่มีเทมเพลต โปรดสร้างเพื่อเริ่มต้น",
      "previewTitle": "ดูตัวอย่างเทมเพลต: {{name}}",
      "emptySection": "(ว่าง)",
      "tooltips": {
        "preview": "ดูตัวอย่าง",
        "edit": "แก้ไข",
        "activate": "เปิดใช้งาน",
        "deactivate": "ปิดใช้งาน"
      },
      "toast": {
        "statusUpdated": "อัปเดตสถานะเทมเพลตแล้ว"
      }
    },
    "form": {
      "editTitle": "แก้ไขเทมเพลต",
      "createTitle": "สร้างเทมเพลต",
      "fields": {
        "name": "ชื่อเทมเพลต",
        "noteType": "ประเภทบันทึก",
        "specialty": "สาขา",
        "sections": "ส่วน"
      },
      "required": "*",
      "namePlaceholder": "เช่น บันทึกความก้าวหน้ามาตรฐาน",
      "selectNoteType": "เลือกประเภท…",
      "selectSpecialty": "เลือกสาขา…",
      "addSection": "เพิ่มส่วน",
      "sectionNamePlaceholder": "ชื่อส่วน (เช่น อาการสำคัญ)",
      "sectionDefaultPlaceholder": "เนื้อหาเริ่มต้นของส่วนนี้…",
      "cancel": "ยกเลิก",
      "create": "สร้างเทมเพลต",
      "update": "อัปเดตเทมเพลต",
      "toast": {
        "created": "สร้างเทมเพลตแล้ว",
        "updated": "อัปเดตเทมเพลตแล้ว",
        "saveFailed": "บันทึกเทมเพลตไม่สำเร็จ",
        "nameAndTypeRequired": "ต้องระบุชื่อและประเภทบันทึก",
        "atLeastOneSection": "ต้องมีอย่างน้อยหนึ่งส่วน"
      }
    },
    "specialty": {
      "general": "เวชศาสตร์ทั่วไป",
      "internalMedicine": "อายุรศาสตร์",
      "surgery": "ศัลยศาสตร์",
      "pediatrics": "กุมารเวชศาสตร์",
      "cardiology": "โรคหัวใจ",
      "neurology": "ประสาทวิทยา",
      "orthopedics": "ออร์โธปิดิกส์",
      "emergencyMedicine": "เวชศาสตร์ฉุกเฉิน"
    },
    "scope": {
      "personal": "ส่วนตัว",
      "group": "กลุ่ม",
      "global": "ทั้งโรงพยาบาล"
    },
    "state": {
      "draft": "ฉบับร่าง",
      "published": "เผยแพร่แล้ว"
    }
  },
  "components": {
    "clinicalNoteEditor": {
      "bold": "ตัวหนา",
      "italic": "ตัวเอียง",
      "list": "รายการ",
      "templates": "เทมเพลต / วลีอัจฉริยะ",
      "saved": "บันทึกแล้ว {{time}}",
      "notSaved": "ยังไม่ได้บันทึก",
      "charactersLabel": "อักขระ",
      "save": "บันทึก{{noteType}}",
      "placeholder": "เริ่มพิมพ์{{noteType}}ของคุณ… ใช้ \".\" เพื่อเรียกวลีอัจฉริยะ",
      "smartPhrases": {
        "patientName": "ชื่อผู้ป่วย",
        "mrn": "เลขเวชระเบียน",
        "dateOfBirth": "วันเกิด",
        "allergies": "ภูมิแพ้",
        "vitals": "สัญญาณชีพ",
        "medications": "ยา",
        "problemList": "รายการปัญหา"
      }
    }
  }
}
